module.exports = __webpack_public_path__ + "img/sayings.e7a1af8.jpg";